import { render, staticRenderFns } from "./ObjectLink.vue?vue&type=template&id=5a8ed4ee&lang=pug"
import script from "./ObjectLink.vue?vue&type=script&lang=js"
export * from "./ObjectLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8ed4ee')) {
      api.createRecord('5a8ed4ee', component.options)
    } else {
      api.reload('5a8ed4ee', component.options)
    }
    module.hot.accept("./ObjectLink.vue?vue&type=template&id=5a8ed4ee&lang=pug", function () {
      api.rerender('5a8ed4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ObjectLink.vue"
export default component.exports